import { db } from '../firebase';
import { 
  collection, 
  doc,
  addDoc,
  getDocs,
  updateDoc,
  query,
  where,
  orderBy,
  serverTimestamp 
} from 'firebase/firestore';

export const skillService = {
  async getUserSkills(userId) {
    try {
      const skillsRef = collection(db, 'skills');
      const q = query(
        skillsRef,
        where('userId', '==', userId),
        orderBy('name')
      );
      
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('Error getting user skills:', error);
      throw error;
    }
  },

  async createSkill(userId, skillData) {
    try {
      const skillsRef = collection(db, 'skills');
      await addDoc(skillsRef, {
        ...skillData,
        userId,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      });
    } catch (error) {
      console.error('Error creating skill:', error);
      throw error;
    }
  },

  async updateSkill(skillId, updates) {
    try {
      const skillRef = doc(db, 'skills', skillId);
      await updateDoc(skillRef, {
        ...updates,
        updatedAt: serverTimestamp()
      });
    } catch (error) {
      console.error('Error updating skill:', error);
      throw error;
    }
  }
}; 